// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1hwJ6","inputDescription":"styles_inputDescription__GgutC"};